// cafe/client/src/components/common/LanguageWrapper.jsx
import { useEffect } from 'react';
import { useParams, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Spinner from '../layout/Spinner';

const supportedLanguages = ['es', 'en', 'pt'];
const defaultLanguage = 'es';

const LanguageWrapper = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // La variable 'currentLang' ha sido eliminada.
    const pathLang = location.pathname.split('/')[1];

    if (!supportedLanguages.includes(pathLang)) {
      const browserLang = navigator.language.split('-')[0];
      const detectedLang = supportedLanguages.includes(browserLang)
        ? browserLang
        : defaultLanguage;

      const newPath = `/${detectedLang}${location.pathname}${location.search}`;
      navigate(newPath, { replace: true });
      return;
    }

    if (i18n.language !== pathLang) {
      i18n.changeLanguage(pathLang);
    }
  }, [location, i18n, navigate, lang]);

  const pathLang = location.pathname.split('/')[1];
  if (!supportedLanguages.includes(pathLang) || i18n.language !== pathLang) {
    return <Spinner />;
  }

  return <Outlet />;
};

export default LanguageWrapper;
